import { Navigate } from "react-router-dom";
import { useStudentAuth } from "../context/StudentAuthContext";

const StudentProtectedRoute = ({ children }) => {
  const { loading, isAuthenticated } = useStudentAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-950 text-neutral-500 dark:text-neutral-400">
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/student-login" replace />;
  }

  return children;
};

export default StudentProtectedRoute;
